import submitCommand from '../../../services/submitCommand';

export const deactivateInvite = (inviteId: string, initiatingUserId: string) => {
  const cmd = { id: inviteId, initiatingUserId: initiatingUserId };

  return submitCommand(inviteId, cmd, 'DeactivateMembershipCode', 'MembershipCodeDeactivated', 'MembershipCodeError');
};
